import React from 'react';
import { useFormikContext } from 'formik';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { srLatn } from 'date-fns/locale';

type DatePickerProps = {
    label: string;
    disabled?: boolean;
    value?: string | number | Date | null;
    disableFuture?: boolean;
    disablePast?: boolean;
    name: string;
    error?: boolean;
    size?: string;
    minDate?: string | number | Date | null;
    maxDate?: string | number | Date | null;
    onChangeDate?: () => void;
};

const DatePicker = (props: DatePickerProps) => {
    const {
        value,
        disableFuture = false,
        disablePast = false,
        label,
        name,
        error = false,
        minDate,
        maxDate,
        disabled,
        onChangeDate = null,
    } = props;
    const { setFieldValue } = useFormikContext();

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Tab') {
            e.preventDefault();
        }
    };

    const dateChange = (val: string | number | Date | null) => {
        setFieldValue(name, val);
        if (!!onChangeDate) {
            onChangeDate();
        }
    };

    return (
        <LocalizationProvider adapterLocale={srLatn} dateAdapter={AdapterDateFns}>
            <MUIDatePicker
                disableFuture={disableFuture}
                disablePast={disablePast}
                label={label}
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                onChange={(val) => dateChange(val)}
                value={value}
                showToolbar={false}
                inputFormat="dd/MM/yyyy"
                renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                    <TextField {...params} error={error} onKeyDown={onKeyDown} />
                )}
            />
        </LocalizationProvider>
    );
};

export default DatePicker;
